import { defineComponent, createElementBlock, createCommentVNode, openBlock, normalizeClass, toDisplayString } from "vue";
const _hoisted_1 = ["href"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HeaderItemLink",
  props: {
    link: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _ctx.link.show ? (openBlock(), createElementBlock("a", {
        key: 0,
        class: normalizeClass(["header-item-link", { "header-item-link__cta": _ctx.link.isButton }]),
        href: _ctx.link.link || "#",
        rel: "noopener noreferrer",
        target: "_blank"
      }, toDisplayString(_ctx.link.title), 11, _hoisted_1)) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=HeaderItemLink.vue.js.map
